import React, { useState } from 'react';

function ServiceRequestForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
    message: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Replace with actual form submission integration (email, API, etc.)
    console.log('Service request submitted:', formData);
    alert('Thank you! Your request has been submitted.');
    setFormData({ name: '', email: '', phone: '', serviceType: '', message: '' });
  };

  return (
    <div className="service-request-form">
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-control"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone">Phone *</label>
            <input
              id="phone"
              name="phone"
              type="tel"
              className="form-control"
              required
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="serviceType">Service Type *</label>
            <select
              id="serviceType"
              name="serviceType"
              className="form-control"
              required
              value={formData.serviceType}
              onChange={handleChange}
            >
              <option value="">Select a service</option>
              <option value="fire-detection">Fire Detection Systems</option>
              <option value="fire-equipment">Fire Protection Equipment</option>
              <option value="electrical">Building Electrical Systems</option>
              <option value="security">Security Systems</option>
            </select>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="message">Message *</label>
          <textarea
            id="message"
            name="message"
            className="form-control"
            rows="5"
            required
            value={formData.message}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Submit Request
        </button>
      </form>
    </div>
  );
}

export default ServiceRequestForm;
